<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12" *ngIf="editar">
      <form [formGroup]="formularioPasosControles" (ngSubmit)="onSubmit()" novalidate id="fCanalesPasosControles" name="fCanalesPasosControles">
        <div class="grid form-group">
          <div class="col-6 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{ 'CONFIGURACIONCANALESESTADO.LBL_CAMPO' | translate }}</label>
              <p-dropdown disableTab  id="idCampos" name="nomCampos" [options]="listaControles" filter="filter" *ngIf="!controlProductoEditar"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                           formControlName="idFlujoVentaPasoControl"
              ></p-dropdown>
              <label class="falso-combo-texto" *ngIf="controlProductoEditar" >{{controlEdicion}}</label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fControls.idFlujoVentaPasoControl.invalid">
                {{ 'CONFIGURACIONCANALESESTADO.LBL_CAMPO' | translate}} {{ 'LBL_REQUERIDO' | translate }}
              </div>
            </div>
          </div>
          <div class="col-6 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{ 'CONFIGURACIONCANALESESTADO.LBL_PRODUCTO' | translate }}</label>
              <p-multiSelect id="idPasosCanal" name="nomPasosCanal" [options]="listaProductos" filter="filter"
                             defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                             selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate }}" formControlName="idProductos"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             optionValue="value"
                             optionLabel="label"
              ></p-multiSelect>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fControls.idProductos.invalid">
                {{ 'CONFIGURACIONCANALESESTADO.LBL_PRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="grid text-center flex">
          <div class="col-12 flex justify-content-center">
            <div *ngIf="!guardando" class="flex align-items-center justify-content-center">
              <a (click)="cancelarEdicion(formularioPasosControles.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12">
      <div class="grid" *ngIf="!showTable">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
          <span>{{'LBL_CONSULTANDO' | translate }}</span>
        </div>
      </div>
      <p-table  *ngIf="showTable" [columns]="columnas" [loading]="carTabla" #dt
               [value]="listaCanalPasoControlesProductos" selectionMode="single"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.codigoFuncionalidadControl}}</td>
            <td>{{row.funcionalidadControl}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorVisible" binary="true" disabled="true"></p-checkbox>
            </td>
            <td>{{row.nombreProductos}}</td>
            <td class="text-center" *ngIf="editar">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-edit" data-toggle="tooltip"
                        title="{{'CONFIGURACIONCANALESESTADO.BTN_EDITARCONTROLES' | translate}}" pButton
                        (click)="editarProductosControl(row)"></button>
                <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_ELIMINAR' | translate}}"
                        pButton (click)="inhabilitarProductosControl(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="col-12" *ngIf="!showTable">
      <div *ngIf="guardando">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_GUARDANDO' | translate }}</span>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="productos-controles" appendTo="body">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
